<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="hideModal()">
                    <span>×</span><span class="sr-only">Close</span>
                </button>
                <h4 class="modal-title">History</h4>
            </div>
            <div class="modal-body">
                <div class="timeline">
                    <ul class="timeline__list" *ngIf="activities.length > 0">
                        <li *ngFor="let a of activities">
                            <section>
                                <header class="timeline__header">
                                <span>
                                    <time>{{ a.createdAt | date:'dd.MM.yyyy hh:mm a' }}</time> by {{ a.fullName }}
                                </span>
                                </header>

                                <main class="timeline__content">
                                    <div [ngSwitch]="a.enable">
                                        <ng-template [ngSwitchCase]="true">
                                            <span class="timeline__active">Read</span>
                                        </ng-template>

                                        <ng-template [ngSwitchCase]="false">
                                            <span class="timeline__active">Marked as unread</span>
                                        </ng-template>
                                    </div>
                                </main>
                            </section>
                        </li>
                    </ul>
                    <div *ngIf="activities.length < 1" class="text-center">No history available for this pass</div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/pass-on-log/pass-on-log-status-history/pass-on-log-status-history.component.html